export class CadasterDataService {
  private static CATRASTRO_API_BASE_URL =
    "https://ovc.catastro.meh.es/OVCServWeb/OVCWcfCallejero/COVCCallejero.svc/json/Consulta_DNPRC";

  static async getCadasterData(
    cadastralReference: string
  ): Promise<
    | { success: true; data: { codigoProvincia: string; codigoMunicipio: string; lconsElements: { lcd: string; stl: number }[], province: string, municipality: string, fullAddress: string } }
    | { success: false; error: string }
  > {
    if (![14, 20].includes(cadastralReference.length)) {
      return { success: false, error: "Invalid RefCat length. Must be 14 or 20 characters." };
    }

    try {
      const url = `${CadasterDataService.CATRASTRO_API_BASE_URL}?RefCat=${encodeURIComponent(cadastralReference)}`;
      const response = await fetch(url);

      if (!response.ok) {
        return {
          success: false,
          error: `Catastro API request failed with status ${response.status}`
        };
      }

      const data = await response.json();
      const result = data?.consulta_dnprcResult;

      if (parseInt(result?.control?.cuerr || "0") > 0) {
        const messages =
          result?.lerr?.map((err: any) => err.des)?.join(", ") || "Unknown error";
        return {
          success: false,
          error: `Catastro API error: ${messages}`
        };
      }

      const cp = result?.bico?.bi?.dt?.loine?.cp || null;
      const cmc = result?.bico?.bi?.dt?.cmc || null;
      const province = result?.bico?.bi?.dt?.np || "";
      const municipality = result?.bico?.bi?.dt?.nm || "";
      const fullAddress = result?.bico?.bi?.ldt || "";

      const lcons = result?.bico?.lcons || [];

      const lconsElements = lcons.reduce((acc: { lcd: string; stl: number }[], lcon: any) => {
        const lcd = lcon?.lcd || "UNKNOWN";
        const stl = parseFloat(lcon?.dfcons?.stl || "0");

        const existing = acc.find(e => e.lcd === lcd);
        if (existing) {
          existing.stl += stl;
        } else {
          acc.push({ lcd, stl });
        }

        return acc;
      }, []);


      if (cp && cmc) {
        return {
          success: true,
          data: {
            codigoProvincia: cp,
            codigoMunicipio: cmc,
            lconsElements: lconsElements,
            province: province,
            municipality: municipality,
            fullAddress: fullAddress
          }
        };
      }

      return {
        success: false,
        error: "Missing province or municipality codes in response."
      };
    } catch (err: any) {
      return {
        success: false,
        error: `Error fetching cadaster data: ${err.message}`
      };
    }
  }
}
